import * as React from 'react';
import { useEffect, useState } from 'react';
import { useSystem } from '../../../../../hooks/useSystem';
import { IntegrationModel, OrganizationModel } from '@journeyapps-platform/lib-journey-core';
import { styled } from '../../../../../theme';
import { IntegrationKind } from '@journeyapps-platform/types-cerberus';
import { AdvancedSelect } from '../AdvancedSelect';

export interface AzureReposDropdownWidgetProps {
  integration: IntegrationModel;
  org: OrganizationModel;
  setProperties: (props: { owner?: string; repo?: string; create?: boolean }) => any;
  repo?: string;
  appName: string;
  groupingName: string;
}

export const AzureReposDropdownWidget: React.FC<AzureReposDropdownWidgetProps> = (props) => {
  const system = useSystem();
  const [repos, setRepos] = useState<{ value: string; label: string }[] | null>(null);
  const integrationProps = props.integration.getProperties<IntegrationKind.AzureDevops>();
  useEffect(() => {
    const client = system.clientProvisioner.provisionProviderClient();
    client
      .getAzureDevopsRepositories({
        org_id: props.org.id,
        azure_project: integrationProps.project,
        azure_organization: integrationProps.organization
      })
      .then((c) => {
        setRepos(
          c.map((repo) => {
            return {
              value: repo.name,
              label: repo.name
            };
          })
        );
      })
      .finally(() => {});
  }, [props.integration.model.id]);

  return (
    <S.SelectContainer padTop={true}>
      <AdvancedSelect {...props} repos={repos} />
    </S.SelectContainer>
  );
};

namespace S {
  export const SelectContainer = styled.div<{ padTop?: boolean }>`
    width: 100%;
    color: ${(p) => p.theme.text.primary};
    margin-top: ${(p) => (p.padTop ? 16 : 0)}px;
  `;
}
